import React from 'react';
import Typography from '@mui/material/Typography';
import "./Footer.css"
import { Link } from 'react-router-dom';
import { openCookieSettings } from '../../contexts/CookieConsentContext';

const Footer = () => {
    return (

        <div className="footer">
            <Typography className='footer-nav' variant="body2" color="text.secondary" align="center">
                <Link to="/" className="footer-link">Home</Link>
                <div className="footer-split"/>
                <Link to="/consensus-rankings" className="footer-link">Consensus Ranking</Link>
                <div className="footer-split"/>
                <Link to="/media-rankings" className="footer-link">Media Rankings</Link>
                <div className="footer-split"/>
                <Link to="/players" className="footer-link">Draft Prospects</Link>
                <div className="footer-split"/>
                <Link to="/blog" className="footer-link">Blog</Link>
                <div className="footer-split"/>
                <Link to="/about-us" className="footer-link">About Us</Link>
                <div className="footer-split"/>
                <Link to="/faq" className="footer-link">FAQ</Link>
                <div className="footer-split"/>
                <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
                <div className="footer-split"/>
                <button type="button" className="footer-link footer-link--button" onClick={openCookieSettings}>
                    Cookie settings
                </button>

            </Typography>
            <Typography className="copy-right" variant="body2" color="text.secondary" align="center">
                © {new Date().getFullYear()} Hockey Pipeline
            </Typography>
        </div>
    );
};

export default Footer;